module.exports = __webpack_public_path__ + "d535a25a79fb1365ae814b61e88fae71.ttf";